export function validArray<T>(arr: T[]): boolean {
  return Array.isArray(arr) && arr.length > 0;
}
